/**
 * File: ModalOverlay.js
 * Origin: isotect
 * Description: ModalOverlay component for displaying a semi-transparent overlay behind modals
 *
 * Version: v1.0.0
 * Created: 2026-02-14
 * Last Updated: 2026-02-14
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ModalOverlay({ onClick }) {
    return <div className="modal-overlay" onClick={onClick}></div>;
}

export default ModalOverlay;
